/**
 * Allgemeines Bootstrap fuer Javascript.
 */
import { vue3bootstrap } from "../scripts/vue3";

import { reinitializeDatepicker, reinitializeCollapsible } from '@/vendor/packages';

$(() => {
    const notifier = Esearcher.Ui.Notifier.getInstance();

    const displayNotifications = (messages) => {
        try {
            Object.entries(messages).forEach(([severity, entries]) => {
                entries.forEach((entry) => {
                    notifier.notify(entry, severity);
                })
            })
        } catch (e) {
            console.log('error while processing message: ');
            console.log(e);
        }
    };

    $(document).on('tabChange', () => {
        notifier.clearAll();
    });

    $(document).on('loadFinish', (_, response) => {
        if (typeof response === 'object' && typeof response.__messages !== 'undefined') {
            displayNotifications(response.__messages);
        }

        /*
         * Initialization of Vendor Packages
         *
         *   - Datepicker elements ($('input[data-datepicker="true"]')) must be initialized by hand.
         *   - Vue 3 elements are ignored because they are initialized later via './vue3/index.js'.
         *   - CkEditor5 elements are ignored because they are initialized later via their own entrypoint.
         */
        reinitializeDatepicker();
        reinitializeCollapsible();

        $('.dataApplier').each((idx, el) => {
            const da = new Esearcher.DataApplier();
            da.bindSelectToText($(el), $('#' + $(el).attr('data-reference-id')));
        });

        vue3bootstrap(notifier);
    }).trigger('loadFinish');

    $(document).on('blockLoadError', () => {
        const errorHtmlObj = $('<html />');

        errorHtmlObj.html(data.toString()).find('script').remove();
        errorHtmlObj.find('#debug_head').remove();

        $('<div id="error-dialog" />').html(errorHtmlObj.html()).dialog({
            title: 'An error occured',
            width: '80%',
            close: function () {
                $(this).dialog('destroy').remove();
            }
        }).show();
    });

    const initPageLogic = () => {
        const curPage = $('body').attr('data-page');
        if (typeof curPage !== 'undefined') {
            for (let i = 0; i < Esearcher.pages.length; i++) {
                if (Esearcher.pages[i].id === curPage) {
                    Esearcher.pages[i].run.call(Esearcher);
                } else {
                    Esearcher.pages.splice(i--, 1);
                }
            }
        } else {
            Esearcher.pages = [];
        }
    };

    initPageLogic();

    /*
     * Handle Top Navbar Save Buttons
     */
    const bootstrapDetectBreakpoint = function () {
        const breakpointNames = ["xl", "lg", "md", "sm", "xs"];
        let breakpointValues = [];
        for (const breakpointName of breakpointNames) {
            breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName);
        }
        let i = breakpointNames.length;
        for (const breakpointName of breakpointNames) {
            i--;
            if (window.matchMedia("(min-width: " + breakpointValues[breakpointName] + ")").matches) {
                return breakpointName;
            }
        }
        return null;
    };

    const currentBreakpoint = bootstrapDetectBreakpoint();

    const bodyElement = document.querySelectorAll('body');
    bodyElement[0].setAttribute('data-layout-breakpoint', currentBreakpoint);

    if (currentBreakpoint === 'md' || currentBreakpoint === 'lg' || currentBreakpoint === 'xl') {

        const elemButtonsTop = document.querySelector('.right-block-buttons > .buttons-top');
        const elemButtonSave = elemButtonsTop && elemButtonsTop.querySelectorAll(":scope > .application-action-save");

        if (elemButtonSave && elemButtonSave.length > 0) {

            const elemOContent = document.querySelector('.o-content');
            const elemOContentDimensions = elemOContent && elemOContent.getBoundingClientRect();

            function isInOContent(element) {
                const rect = element.getBoundingClientRect();
                return (
                    rect.top >= elemOContentDimensions.top &&
                    rect.left >= elemOContentDimensions.left &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            document.addEventListener('scroll', function () {
                if (elemButtonSave && isInOContent(elemButtonSave[0])) {
                    const elemButtonsTop = document.querySelector('.right-block-buttons > .buttons-top');
                    if (elemButtonsTop !== undefined && elemButtonsTop.classList.contains('hidden')) {
                        elemButtonsTop.classList.remove('hidden');
                        const elemButtonSave = elemButtonsTop.querySelectorAll(":scope > .application-action-save");
                        if (elemButtonSave !== undefined && elemButtonSave[0].classList.contains('hidden')) {
                            elemButtonSave[0].classList.remove('hidden');
                        }
                    }

                    const elemInfoAreaDefaultTopBar = document.querySelector('.top-navbar-info-area-default');
                    if (elemInfoAreaDefaultTopBar !== undefined && !elemInfoAreaDefaultTopBar.classList.contains('hidden')) {
                        elemInfoAreaDefaultTopBar.classList.add('hidden');
                        const elemButtonSave = elemInfoAreaDefaultTopBar.querySelectorAll(":scope > .application-action-save");
                        if (elemButtonSave !== undefined && !elemButtonSave[0].classList.contains('hidden')) {
                            elemButtonSave[0].classList.add('hidden');
                        }
                    }
                }
                if (elemButtonSave && !isInOContent(elemButtonSave[0])) {
                    const elemButtonsTop = document.querySelector('.right-block-buttons > .buttons-top');
                    if (elemButtonsTop !== undefined && !elemButtonsTop.classList.contains('hidden')) {
                        elemButtonsTop.classList.add('hidden');
                        const elemButtonSave = elemButtonsTop.querySelectorAll(":scope > .application-action-save");
                        if (elemButtonSave !== undefined && !elemButtonSave[0].classList.contains('hidden')) {
                            elemButtonSave[0].classList.add('hidden');
                        }
                    }

                    const elemInfoAreaDefaultTopBar = document.querySelector('.top-navbar-info-area-default');
                    if (elemInfoAreaDefaultTopBar !== undefined && elemInfoAreaDefaultTopBar.classList.contains('hidden')) {
                        elemInfoAreaDefaultTopBar.classList.remove('hidden');
                        const elemButtonSave = elemInfoAreaDefaultTopBar.querySelectorAll(":scope > .application-action-save");
                        if (elemButtonSave !== undefined && elemButtonSave[0].classList.contains('hidden')) {
                            elemButtonSave[0].classList.remove('hidden');
                        }
                    }
                }
            }, {
                passive: true
            })
        }
    }
});
